module.exports = Ember.HTMLBars.template((function() {
  var child0 = (function() {
    var child0 = (function() {
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          var el1 = dom.createComment("");
          dom.appendChild(el0, el1);
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          var hooks = env.hooks, inline = hooks.inline;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
          dom.insertBoundary(fragment, null);
          dom.insertBoundary(fragment, 0);
          inline(env, morph0, context, "t", ["categories.enable_drag"], {});
          return fragment;
        }
      };
    }());
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","sidebar-block thin darken");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, get = hooks.get, block = hooks.block;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
        block(env, morph0, context, "sm-checkbox", [], {"checked": get(env, context, "isDragEnabled")}, child0, null);
        return fragment;
      }
    };
  }());
  var child1 = (function() {
    var child0 = (function() {
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          var el1 = dom.createComment("");
          dom.appendChild(el0, el1);
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          var hooks = env.hooks, inline = hooks.inline;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
          dom.insertBoundary(fragment, null);
          dom.insertBoundary(fragment, 0);
          inline(env, morph0, context, "t", ["categories.new_configurator.categories"], {});
          return fragment;
        }
      };
    }());
    var child1 = (function() {
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          var el1 = dom.createComment("");
          dom.appendChild(el0, el1);
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          var hooks = env.hooks, inline = hooks.inline;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
          dom.insertBoundary(fragment, null);
          dom.insertBoundary(fragment, 0);
          inline(env, morph0, context, "t", ["categories.new_configurator.modifiers"], {});
          return fragment;
        }
      };
    }());
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","sidebar-block thin darken");
        var el2 = dom.createElement("div");
        dom.setAttribute(el2,"class","sm-segmented");
        var el3 = dom.createComment("");
        dom.appendChild(el2, el3);
        var el3 = dom.createComment("");
        dom.appendChild(el2, el3);
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, block = hooks.block;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var element10 = dom.childAt(fragment, [0, 0]);
        var morph0 = dom.createMorphAt(element10,0,0);
        var morph1 = dom.createMorphAt(element10,1,1);
        block(env, morph0, context, "link-to", ["categories"], {"classNames": "sm-segment"}, child0, null);
        block(env, morph1, context, "link-to", ["modifier-groups"], {"classNames": "sm-segment"}, child1, null);
        return fragment;
      }
    };
  }());
  var child2 = (function() {
    var child0 = (function() {
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          return fragment;
        }
      };
    }());
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","sidebar-block");
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        var el2 = dom.createElement("div");
        dom.setAttribute(el2,"class","publication-time");
        var el3 = dom.createComment("");
        dom.appendChild(el2, el3);
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, get = hooks.get, block = hooks.block, content = hooks.content;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var element9 = dom.childAt(fragment, [0]);
        var morph0 = dom.createMorphAt(element9,0,0);
        var morph1 = dom.createMorphAt(dom.childAt(element9, [1]),0,0);
        block(env, morph0, context, "sm-button", [], {"textTranslation": "categories.publish", "classNames": "large full-width", "type": "primary", "isLoading": get(env, context, "publishIsLoading"), "disabled": get(env, context, "isMenuActual"), "action": "publishMenu"}, child0, null);
        content(env, morph1, context, "publishedAt");
        return fragment;
      }
    };
  }());
  var child3 = (function() {
    var child0 = (function() {
      var child0 = (function() {
        var child0 = (function() {
          return {
            isHTMLBars: true,
            revision: "Ember@1.11.1",
            blockParams: 0,
            cachedFragment: null,
            hasRendered: false,
            build: function build(dom) {
              var el0 = dom.createDocumentFragment();
              var el1 = dom.createElement("div");
              dom.setAttribute(el1,"class","v-wrap");
              var el2 = dom.createElement("div");
              dom.setAttribute(el2,"class","image");
              dom.appendChild(el1, el2);
              var el2 = dom.createElement("div");
              dom.setAttribute(el2,"class","text");
              var el3 = dom.createElement("div");
              dom.setAttribute(el3,"class","name");
              var el4 = dom.createComment("");
              dom.appendChild(el3, el4);
              dom.appendChild(el2, el3);
              dom.appendChild(el1, el2);
              dom.appendChild(el0, el1);
              return el0;
            },
            render: function render(context, env, contextualElement) {
              var dom = env.dom;
              var hooks = env.hooks, get = hooks.get, element = hooks.element, content = hooks.content;
              dom.detectNamespace(contextualElement);
              var fragment;
              if (env.useFragmentCache && dom.canClone) {
                if (this.cachedFragment === null) {
                  fragment = this.build(dom);
                  if (this.hasRendered) {
                    this.cachedFragment = fragment;
                  } else {
                    this.hasRendered = true;
                  }
                }
                if (this.cachedFragment) {
                  fragment = dom.cloneNode(this.cachedFragment, true);
                }
              } else {
                fragment = this.build(dom);
              }
              var element7 = dom.childAt(fragment, [0]);
              var element8 = dom.childAt(element7, [0]);
              var morph0 = dom.createMorphAt(dom.childAt(element7, [1, 0]),0,0);
              element(env, element8, context, "bind-attr", [], {"style": get(env, context, "category.photoSmallBackground")});
              content(env, morph0, context, "category.name");
              return fragment;
            }
          };
        }());
        var child1 = (function() {
          var child0 = (function() {
            var child0 = (function() {
              var child0 = (function() {
                var child0 = (function() {
                  return {
                    isHTMLBars: true,
                    revision: "Ember@1.11.1",
                    blockParams: 0,
                    cachedFragment: null,
                    hasRendered: false,
                    build: function build(dom) {
                      var el0 = dom.createDocumentFragment();
                      var el1 = dom.createElement("div");
                      dom.setAttribute(el1,"class","v-wrap");
                      var el2 = dom.createElement("div");
                      dom.setAttribute(el2,"class","image");
                      dom.appendChild(el1, el2);
                      var el2 = dom.createElement("div");
                      dom.setAttribute(el2,"class","text");
                      var el3 = dom.createElement("div");
                      dom.setAttribute(el3,"class","name");
                      var el4 = dom.createComment("");
                      dom.appendChild(el3, el4);
                      dom.appendChild(el2, el3);
                      dom.appendChild(el1, el2);
                      dom.appendChild(el0, el1);
                      return el0;
                    },
                    render: function render(context, env, contextualElement) {
                      var dom = env.dom;
                      var hooks = env.hooks, get = hooks.get, element = hooks.element, content = hooks.content;
                      dom.detectNamespace(contextualElement);
                      var fragment;
                      if (env.useFragmentCache && dom.canClone) {
                        if (this.cachedFragment === null) {
                          fragment = this.build(dom);
                          if (this.hasRendered) {
                            this.cachedFragment = fragment;
                          } else {
                            this.hasRendered = true;
                          }
                        }
                        if (this.cachedFragment) {
                          fragment = dom.cloneNode(this.cachedFragment, true);
                        }
                      } else {
                        fragment = this.build(dom);
                      }
                      var element5 = dom.childAt(fragment, [0]);
                      var element6 = dom.childAt(element5, [0]);
                      var morph0 = dom.createMorphAt(dom.childAt(element5, [1, 0]),0,0);
                      element(env, element6, context, "bind-attr", [], {"style": get(env, context, "category.photoSmallBackground")});
                      content(env, morph0, context, "category.name");
                      return fragment;
                    }
                  };
                }());
                var child1 = (function() {
                  var child0 = (function() {
                    var child0 = (function() {
                      var child0 = (function() {
                        var child0 = (function() {
                          return {
                            isHTMLBars: true,
                            revision: "Ember@1.11.1",
                            blockParams: 0,
                            cachedFragment: null,
                            hasRendered: false,
                            build: function build(dom) {
                              var el0 = dom.createDocumentFragment();
                              var el1 = dom.createElement("div");
                              dom.setAttribute(el1,"class","v-wrap");
                              var el2 = dom.createElement("div");
                              dom.setAttribute(el2,"class","image");
                              dom.appendChild(el1, el2);
                              var el2 = dom.createElement("div");
                              dom.setAttribute(el2,"class","text");
                              var el3 = dom.createElement("div");
                              dom.setAttribute(el3,"class","name");
                              var el4 = dom.createComment("");
                              dom.appendChild(el3, el4);
                              dom.appendChild(el2, el3);
                              dom.appendChild(el1, el2);
                              dom.appendChild(el0, el1);
                              return el0;
                            },
                            render: function render(context, env, contextualElement) {
                              var dom = env.dom;
                              var hooks = env.hooks, get = hooks.get, element = hooks.element, content = hooks.content;
                              dom.detectNamespace(contextualElement);
                              var fragment;
                              if (env.useFragmentCache && dom.canClone) {
                                if (this.cachedFragment === null) {
                                  fragment = this.build(dom);
                                  if (this.hasRendered) {
                                    this.cachedFragment = fragment;
                                  } else {
                                    this.hasRendered = true;
                                  }
                                }
                                if (this.cachedFragment) {
                                  fragment = dom.cloneNode(this.cachedFragment, true);
                                }
                              } else {
                                fragment = this.build(dom);
                              }
                              var element3 = dom.childAt(fragment, [0]);
                              var element4 = dom.childAt(element3, [0]);
                              var morph0 = dom.createMorphAt(dom.childAt(element3, [1, 0]),0,0);
                              element(env, element4, context, "bind-attr", [], {"style": get(env, context, "category.photoSmallBackground")});
                              content(env, morph0, context, "category.name");
                              return fragment;
                            }
                          };
                        }());
                        var child1 = (function() {
                          var child0 = (function() {
                            var child0 = (function() {
                              var child0 = (function() {
                                var child0 = (function() {
                                  return {
                                    isHTMLBars: true,
                                    revision: "Ember@1.11.1",
                                    blockParams: 0,
                                    cachedFragment: null,
                                    hasRendered: false,
                                    build: function build(dom) {
                                      var el0 = dom.createDocumentFragment();
                                      var el1 = dom.createElement("div");
                                      dom.setAttribute(el1,"class","v-wrap");
                                      var el2 = dom.createElement("div");
                                      dom.setAttribute(el2,"class","image");
                                      dom.appendChild(el1, el2);
                                      var el2 = dom.createElement("div");
                                      dom.setAttribute(el2,"class","text");
                                      var el3 = dom.createElement("div");
                                      dom.setAttribute(el3,"class","name");
                                      var el4 = dom.createComment("");
                                      dom.appendChild(el3, el4);
                                      dom.appendChild(el2, el3);
                                      dom.appendChild(el1, el2);
                                      dom.appendChild(el0, el1);
                                      return el0;
                                    },
                                    render: function render(context, env, contextualElement) {
                                      var dom = env.dom;
                                      var hooks = env.hooks, get = hooks.get, element = hooks.element, content = hooks.content;
                                      dom.detectNamespace(contextualElement);
                                      var fragment;
                                      if (env.useFragmentCache && dom.canClone) {
                                        if (this.cachedFragment === null) {
                                          fragment = this.build(dom);
                                          if (this.hasRendered) {
                                            this.cachedFragment = fragment;
                                          } else {
                                            this.hasRendered = true;
                                          }
                                        }
                                        if (this.cachedFragment) {
                                          fragment = dom.cloneNode(this.cachedFragment, true);
                                        }
                                      } else {
                                        fragment = this.build(dom);
                                      }
                                      var element1 = dom.childAt(fragment, [0]);
                                      var element2 = dom.childAt(element1, [0]);
                                      var morph0 = dom.createMorphAt(dom.childAt(element1, [1, 0]),0,0);
                                      element(env, element2, context, "bind-attr", [], {"style": get(env, context, "category.photoSmallBackground")});
                                      content(env, morph0, context, "category.name");
                                      return fragment;
                                    }
                                  };
                                }());
                                return {
                                  isHTMLBars: true,
                                  revision: "Ember@1.11.1",
                                  blockParams: 0,
                                  cachedFragment: null,
                                  hasRendered: false,
                                  build: function build(dom) {
                                    var el0 = dom.createDocumentFragment();
                                    var el1 = dom.createComment("");
                                    dom.appendChild(el0, el1);
                                    return el0;
                                  },
                                  render: function render(context, env, contextualElement) {
                                    var dom = env.dom;
                                    var hooks = env.hooks, get = hooks.get, block = hooks.block;
                                    dom.detectNamespace(contextualElement);
                                    var fragment;
                                    if (env.useFragmentCache && dom.canClone) {
                                      if (this.cachedFragment === null) {
                                        fragment = this.build(dom);
                                        if (this.hasRendered) {
                                          this.cachedFragment = fragment;
                                        } else {
                                          this.hasRendered = true;
                                        }
                                      }
                                      if (this.cachedFragment) {
                                        fragment = dom.cloneNode(this.cachedFragment, true);
                                      }
                                    } else {
                                      fragment = this.build(dom);
                                    }
                                    var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                                    dom.insertBoundary(fragment, null);
                                    dom.insertBoundary(fragment, 0);
                                    block(env, morph0, context, "link-to", ["category", get(env, context, "category.id")], {"activeClass": "selected"}, child0, null);
                                    return fragment;
                                  }
                                };
                              }());
                              return {
                                isHTMLBars: true,
                                revision: "Ember@1.11.1",
                                blockParams: 0,
                                cachedFragment: null,
                                hasRendered: false,
                                build: function build(dom) {
                                  var el0 = dom.createDocumentFragment();
                                  var el1 = dom.createComment("");
                                  dom.appendChild(el0, el1);
                                  return el0;
                                },
                                render: function render(context, env, contextualElement) {
                                  var dom = env.dom;
                                  var hooks = env.hooks, get = hooks.get, block = hooks.block;
                                  dom.detectNamespace(contextualElement);
                                  var fragment;
                                  if (env.useFragmentCache && dom.canClone) {
                                    if (this.cachedFragment === null) {
                                      fragment = this.build(dom);
                                      if (this.hasRendered) {
                                        this.cachedFragment = fragment;
                                      } else {
                                        this.hasRendered = true;
                                      }
                                    }
                                    if (this.cachedFragment) {
                                      fragment = dom.cloneNode(this.cachedFragment, true);
                                    }
                                  } else {
                                    fragment = this.build(dom);
                                  }
                                  var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                                  dom.insertBoundary(fragment, null);
                                  dom.insertBoundary(fragment, 0);
                                  block(env, morph0, context, "sm-sortable-item", [], {"model": get(env, context, "category")}, child0, null);
                                  return fragment;
                                }
                              };
                            }());
                            return {
                              isHTMLBars: true,
                              revision: "Ember@1.11.1",
                              blockParams: 0,
                              cachedFragment: null,
                              hasRendered: false,
                              build: function build(dom) {
                                var el0 = dom.createDocumentFragment();
                                var el1 = dom.createComment("");
                                dom.appendChild(el0, el1);
                                return el0;
                              },
                              render: function render(context, env, contextualElement) {
                                var dom = env.dom;
                                var hooks = env.hooks, get = hooks.get, block = hooks.block;
                                dom.detectNamespace(contextualElement);
                                var fragment;
                                if (env.useFragmentCache && dom.canClone) {
                                  if (this.cachedFragment === null) {
                                    fragment = this.build(dom);
                                    if (this.hasRendered) {
                                      this.cachedFragment = fragment;
                                    } else {
                                      this.hasRendered = true;
                                    }
                                  }
                                  if (this.cachedFragment) {
                                    fragment = dom.cloneNode(this.cachedFragment, true);
                                  }
                                } else {
                                  fragment = this.build(dom);
                                }
                                var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                                dom.insertBoundary(fragment, null);
                                dom.insertBoundary(fragment, 0);
                                block(env, morph0, context, "each", [get(env, context, "category.draft_categories")], {"keyword": "category"}, child0, null);
                                return fragment;
                              }
                            };
                          }());
                          return {
                            isHTMLBars: true,
                            revision: "Ember@1.11.1",
                            blockParams: 0,
                            cachedFragment: null,
                            hasRendered: false,
                            build: function build(dom) {
                              var el0 = dom.createDocumentFragment();
                              var el1 = dom.createElement("div");
                              dom.setAttribute(el1,"class","link-list level-3");
                              var el2 = dom.createComment("");
                              dom.appendChild(el1, el2);
                              dom.appendChild(el0, el1);
                              return el0;
                            },
                            render: function render(context, env, contextualElement) {
                              var dom = env.dom;
                              var hooks = env.hooks, get = hooks.get, block = hooks.block;
                              dom.detectNamespace(contextualElement);
                              var fragment;
                              if (env.useFragmentCache && dom.canClone) {
                                if (this.cachedFragment === null) {
                                  fragment = this.build(dom);
                                  if (this.hasRendered) {
                                    this.cachedFragment = fragment;
                                  } else {
                                    this.hasRendered = true;
                                  }
                                }
                                if (this.cachedFragment) {
                                  fragment = dom.cloneNode(this.cachedFragment, true);
                                }
                              } else {
                                fragment = this.build(dom);
                              }
                              var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
                              block(env, morph0, context, "sm-sortable", [], {"disabled": get(env, context, "smSortableDisabled"), "onItemReorder": "reorderCategory"}, child0, null);
                              return fragment;
                            }
                          };
                        }());
                        return {
                          isHTMLBars: true,
                          revision: "Ember@1.11.1",
                          blockParams: 0,
                          cachedFragment: null,
                          hasRendered: false,
                          build: function build(dom) {
                            var el0 = dom.createDocumentFragment();
                            var el1 = dom.createComment("");
                            dom.appendChild(el0, el1);
                            var el1 = dom.createComment("");
                            dom.appendChild(el0, el1);
                            return el0;
                          },
                          render: function render(context, env, contextualElement) {
                            var dom = env.dom;
                            var hooks = env.hooks, get = hooks.get, block = hooks.block;
                            dom.detectNamespace(contextualElement);
                            var fragment;
                            if (env.useFragmentCache && dom.canClone) {
                              if (this.cachedFragment === null) {
                                fragment = this.build(dom);
                                if (this.hasRendered) {
                                  this.cachedFragment = fragment;
                                } else {
                                  this.hasRendered = true;
                                }
                              }
                              if (this.cachedFragment) {
                                fragment = dom.cloneNode(this.cachedFragment, true);
                              }
                            } else {
                              fragment = this.build(dom);
                            }
                            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                            var morph1 = dom.createMorphAt(fragment,1,1,contextualElement);
                            dom.insertBoundary(fragment, null);
                            dom.insertBoundary(fragment, 0);
                            block(env, morph0, context, "link-to", ["category", get(env, context, "category.id")], {"activeClass": "selected"}, child0, null);
                            block(env, morph1, context, "if", [get(env, context, "category.draft_categories")], {}, child1, null);
                            return fragment;
                          }
                        };
                      }());
                      return {
                        isHTMLBars: true,
                        revision: "Ember@1.11.1",
                        blockParams: 0,
                        cachedFragment: null,
                        hasRendered: false,
                        build: function build(dom) {
                          var el0 = dom.createDocumentFragment();
                          var el1 = dom.createComment("");
                          dom.appendChild(el0, el1);
                          return el0;
                        },
                        render: function render(context, env, contextualElement) {
                          var dom = env.dom;
                          var hooks = env.hooks, get = hooks.get, block = hooks.block;
                          dom.detectNamespace(contextualElement);
                          var fragment;
                          if (env.useFragmentCache && dom.canClone) {
                            if (this.cachedFragment === null) {
                              fragment = this.build(dom);
                              if (this.hasRendered) {
                                this.cachedFragment = fragment;
                              } else {
                                this.hasRendered = true;
                              }
                            }
                            if (this.cachedFragment) {
                              fragment = dom.cloneNode(this.cachedFragment, true);
                            }
                          } else {
                            fragment = this.build(dom);
                          }
                          var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                          dom.insertBoundary(fragment, null);
                          dom.insertBoundary(fragment, 0);
                          block(env, morph0, context, "sm-sortable-item", [], {"model": get(env, context, "category")}, child0, null);
                          return fragment;
                        }
                      };
                    }());
                    return {
                      isHTMLBars: true,
                      revision: "Ember@1.11.1",
                      blockParams: 0,
                      cachedFragment: null,
                      hasRendered: false,
                      build: function build(dom) {
                        var el0 = dom.createDocumentFragment();
                        var el1 = dom.createComment("");
                        dom.appendChild(el0, el1);
                        return el0;
                      },
                      render: function render(context, env, contextualElement) {
                        var dom = env.dom;
                        var hooks = env.hooks, get = hooks.get, block = hooks.block;
                        dom.detectNamespace(contextualElement);
                        var fragment;
                        if (env.useFragmentCache && dom.canClone) {
                          if (this.cachedFragment === null) {
                            fragment = this.build(dom);
                            if (this.hasRendered) {
                              this.cachedFragment = fragment;
                            } else {
                              this.hasRendered = true;
                            }
                          }
                          if (this.cachedFragment) {
                            fragment = dom.cloneNode(this.cachedFragment, true);
                          }
                        } else {
                          fragment = this.build(dom);
                        }
                        var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                        dom.insertBoundary(fragment, null);
                        dom.insertBoundary(fragment, 0);
                        block(env, morph0, context, "each", [get(env, context, "category.draft_categories")], {"keyword": "category"}, child0, null);
                        return fragment;
                      }
                    };
                  }());
                  return {
                    isHTMLBars: true,
                    revision: "Ember@1.11.1",
                    blockParams: 0,
                    cachedFragment: null,
                    hasRendered: false,
                    build: function build(dom) {
                      var el0 = dom.createDocumentFragment();
                      var el1 = dom.createElement("div");
                      dom.setAttribute(el1,"class","link-list level-2");
                      var el2 = dom.createComment("");
                      dom.appendChild(el1, el2);
                      dom.appendChild(el0, el1);
                      return el0;
                    },
                    render: function render(context, env, contextualElement) {
                      var dom = env.dom;
                      var hooks = env.hooks, get = hooks.get, block = hooks.block;
                      dom.detectNamespace(contextualElement);
                      var fragment;
                      if (env.useFragmentCache && dom.canClone) {
                        if (this.cachedFragment === null) {
                          fragment = this.build(dom);
                          if (this.hasRendered) {
                            this.cachedFragment = fragment;
                          } else {
                            this.hasRendered = true;
                          }
                        }
                        if (this.cachedFragment) {
                          fragment = dom.cloneNode(this.cachedFragment, true);
                        }
                      } else {
                        fragment = this.build(dom);
                      }
                      var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
                      block(env, morph0, context, "sm-sortable", [], {"disabled": get(env, context, "smSortableDisabled"), "onItemReorder": "reorderCategory"}, child0, null);
                      return fragment;
                    }
                  };
                }());
                return {
                  isHTMLBars: true,
                  revision: "Ember@1.11.1",
                  blockParams: 0,
                  cachedFragment: null,
                  hasRendered: false,
                  build: function build(dom) {
                    var el0 = dom.createDocumentFragment();
                    var el1 = dom.createComment("");
                    dom.appendChild(el0, el1);
                    var el1 = dom.createComment("");
                    dom.appendChild(el0, el1);
                    return el0;
                  },
                  render: function render(context, env, contextualElement) {
                    var dom = env.dom;
                    var hooks = env.hooks, get = hooks.get, block = hooks.block;
                    dom.detectNamespace(contextualElement);
                    var fragment;
                    if (env.useFragmentCache && dom.canClone) {
                      if (this.cachedFragment === null) {
                        fragment = this.build(dom);
                        if (this.hasRendered) {
                          this.cachedFragment = fragment;
                        } else {
                          this.hasRendered = true;
                        }
                      }
                      if (this.cachedFragment) {
                        fragment = dom.cloneNode(this.cachedFragment, true);
                      }
                    } else {
                      fragment = this.build(dom);
                    }
                    var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                    var morph1 = dom.createMorphAt(fragment,1,1,contextualElement);
                    dom.insertBoundary(fragment, null);
                    dom.insertBoundary(fragment, 0);
                    block(env, morph0, context, "link-to", ["category", get(env, context, "category.id")], {"activeClass": "selected"}, child0, null);
                    block(env, morph1, context, "if", [get(env, context, "category.draft_categories")], {}, child1, null);
                    return fragment;
                  }
                };
              }());
              return {
                isHTMLBars: true,
                revision: "Ember@1.11.1",
                blockParams: 0,
                cachedFragment: null,
                hasRendered: false,
                build: function build(dom) {
                  var el0 = dom.createDocumentFragment();
                  var el1 = dom.createComment("");
                  dom.appendChild(el0, el1);
                  return el0;
                },
                render: function render(context, env, contextualElement) {
                  var dom = env.dom;
                  var hooks = env.hooks, get = hooks.get, block = hooks.block;
                  dom.detectNamespace(contextualElement);
                  var fragment;
                  if (env.useFragmentCache && dom.canClone) {
                    if (this.cachedFragment === null) {
                      fragment = this.build(dom);
                      if (this.hasRendered) {
                        this.cachedFragment = fragment;
                      } else {
                        this.hasRendered = true;
                      }
                    }
                    if (this.cachedFragment) {
                      fragment = dom.cloneNode(this.cachedFragment, true);
                    }
                  } else {
                    fragment = this.build(dom);
                  }
                  var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                  dom.insertBoundary(fragment, null);
                  dom.insertBoundary(fragment, 0);
                  block(env, morph0, context, "sm-sortable-item", [], {"model": get(env, context, "category")}, child0, null);
                  return fragment;
                }
              };
            }());
            return {
              isHTMLBars: true,
              revision: "Ember@1.11.1",
              blockParams: 0,
              cachedFragment: null,
              hasRendered: false,
              build: function build(dom) {
                var el0 = dom.createDocumentFragment();
                var el1 = dom.createComment("");
                dom.appendChild(el0, el1);
                return el0;
              },
              render: function render(context, env, contextualElement) {
                var dom = env.dom;
                var hooks = env.hooks, get = hooks.get, block = hooks.block;
                dom.detectNamespace(contextualElement);
                var fragment;
                if (env.useFragmentCache && dom.canClone) {
                  if (this.cachedFragment === null) {
                    fragment = this.build(dom);
                    if (this.hasRendered) {
                      this.cachedFragment = fragment;
                    } else {
                      this.hasRendered = true;
                    }
                  }
                  if (this.cachedFragment) {
                    fragment = dom.cloneNode(this.cachedFragment, true);
                  }
                } else {
                  fragment = this.build(dom);
                }
                var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
                dom.insertBoundary(fragment, null);
                dom.insertBoundary(fragment, 0);
                block(env, morph0, context, "each", [get(env, context, "category.draft_categories")], {"keyword": "category"}, child0, null);
                return fragment;
              }
            };
          }());
          return {
            isHTMLBars: true,
            revision: "Ember@1.11.1",
            blockParams: 0,
            cachedFragment: null,
            hasRendered: false,
            build: function build(dom) {
              var el0 = dom.createDocumentFragment();
              var el1 = dom.createElement("div");
              dom.setAttribute(el1,"class","link-list level-1");
              var el2 = dom.createComment("");
              dom.appendChild(el1, el2);
              dom.appendChild(el0, el1);
              return el0;
            },
            render: function render(context, env, contextualElement) {
              var dom = env.dom;
              var hooks = env.hooks, get = hooks.get, block = hooks.block;
              dom.detectNamespace(contextualElement);
              var fragment;
              if (env.useFragmentCache && dom.canClone) {
                if (this.cachedFragment === null) {
                  fragment = this.build(dom);
                  if (this.hasRendered) {
                    this.cachedFragment = fragment;
                  } else {
                    this.hasRendered = true;
                  }
                }
                if (this.cachedFragment) {
                  fragment = dom.cloneNode(this.cachedFragment, true);
                }
              } else {
                fragment = this.build(dom);
              }
              var morph0 = dom.createMorphAt(dom.childAt(fragment, [0]),0,0);
              block(env, morph0, context, "sm-sortable", [], {"disabled": get(env, context, "smSortableDisabled"), "onItemReorder": "reorderCategory"}, child0, null);
              return fragment;
            }
          };
        }());
        return {
          isHTMLBars: true,
          revision: "Ember@1.11.1",
          blockParams: 0,
          cachedFragment: null,
          hasRendered: false,
          build: function build(dom) {
            var el0 = dom.createDocumentFragment();
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            var el1 = dom.createComment("");
            dom.appendChild(el0, el1);
            return el0;
          },
          render: function render(context, env, contextualElement) {
            var dom = env.dom;
            var hooks = env.hooks, get = hooks.get, block = hooks.block;
            dom.detectNamespace(contextualElement);
            var fragment;
            if (env.useFragmentCache && dom.canClone) {
              if (this.cachedFragment === null) {
                fragment = this.build(dom);
                if (this.hasRendered) {
                  this.cachedFragment = fragment;
                } else {
                  this.hasRendered = true;
                }
              }
              if (this.cachedFragment) {
                fragment = dom.cloneNode(this.cachedFragment, true);
              }
            } else {
              fragment = this.build(dom);
            }
            var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
            var morph1 = dom.createMorphAt(fragment,1,1,contextualElement);
            dom.insertBoundary(fragment, null);
            dom.insertBoundary(fragment, 0);
            block(env, morph0, context, "link-to", ["category", get(env, context, "category.id")], {"activeClass": "selected"}, child0, null);
            block(env, morph1, context, "if", [get(env, context, "category.draft_categories")], {}, child1, null);
            return fragment;
          }
        };
      }());
      return {
        isHTMLBars: true,
        revision: "Ember@1.11.1",
        blockParams: 0,
        cachedFragment: null,
        hasRendered: false,
        build: function build(dom) {
          var el0 = dom.createDocumentFragment();
          var el1 = dom.createComment("");
          dom.appendChild(el0, el1);
          return el0;
        },
        render: function render(context, env, contextualElement) {
          var dom = env.dom;
          var hooks = env.hooks, get = hooks.get, block = hooks.block;
          dom.detectNamespace(contextualElement);
          var fragment;
          if (env.useFragmentCache && dom.canClone) {
            if (this.cachedFragment === null) {
              fragment = this.build(dom);
              if (this.hasRendered) {
                this.cachedFragment = fragment;
              } else {
                this.hasRendered = true;
              }
            }
            if (this.cachedFragment) {
              fragment = dom.cloneNode(this.cachedFragment, true);
            }
          } else {
            fragment = this.build(dom);
          }
          var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
          dom.insertBoundary(fragment, null);
          dom.insertBoundary(fragment, 0);
          block(env, morph0, context, "sm-sortable-item", [], {"model": get(env, context, "category")}, child0, null);
          return fragment;
        }
      };
    }());
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createComment("");
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, get = hooks.get, block = hooks.block;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var morph0 = dom.createMorphAt(fragment,0,0,contextualElement);
        dom.insertBoundary(fragment, null);
        dom.insertBoundary(fragment, 0);
        block(env, morph0, context, "each", [get(env, context, "sortedCategories")], {"keyword": "category"}, child0, null);
        return fragment;
      }
    };
  }());
  var child4 = (function() {
    return {
      isHTMLBars: true,
      revision: "Ember@1.11.1",
      blockParams: 0,
      cachedFragment: null,
      hasRendered: false,
      build: function build(dom) {
        var el0 = dom.createDocumentFragment();
        var el1 = dom.createElement("div");
        dom.setAttribute(el1,"class","add-element");
        var el2 = dom.createElement("div");
        dom.setAttribute(el2,"class","plus-icon");
        dom.appendChild(el1, el2);
        var el2 = dom.createComment("");
        dom.appendChild(el1, el2);
        dom.appendChild(el0, el1);
        return el0;
      },
      render: function render(context, env, contextualElement) {
        var dom = env.dom;
        var hooks = env.hooks, element = hooks.element, inline = hooks.inline;
        dom.detectNamespace(contextualElement);
        var fragment;
        if (env.useFragmentCache && dom.canClone) {
          if (this.cachedFragment === null) {
            fragment = this.build(dom);
            if (this.hasRendered) {
              this.cachedFragment = fragment;
            } else {
              this.hasRendered = true;
            }
          }
          if (this.cachedFragment) {
            fragment = dom.cloneNode(this.cachedFragment, true);
          }
        } else {
          fragment = this.build(dom);
        }
        var element0 = dom.childAt(fragment, [0]);
        var morph0 = dom.createMorphAt(element0,1,1);
        element(env, element0, context, "action", ["addCategory"], {"on": "click"});
        inline(env, morph0, context, "t", ["categories.add_category"], {});
        return fragment;
      }
    };
  }());
  return {
    isHTMLBars: true,
    revision: "Ember@1.11.1",
    blockParams: 0,
    cachedFragment: null,
    hasRendered: false,
    build: function build(dom) {
      var el0 = dom.createDocumentFragment();
      var el1 = dom.createElement("div");
      dom.setAttribute(el1,"class","sidebar-layout menu-route");
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","sidebar");
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("div");
      dom.setAttribute(el3,"class","link-list");
      var el4 = dom.createComment("");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      var el2 = dom.createElement("div");
      dom.setAttribute(el2,"class","main-content");
      var el3 = dom.createComment("");
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      return el0;
    },
    render: function render(context, env, contextualElement) {
      var dom = env.dom;
      var hooks = env.hooks, get = hooks.get, block = hooks.block, content = hooks.content;
      dom.detectNamespace(contextualElement);
      var fragment;
      if (env.useFragmentCache && dom.canClone) {
        if (this.cachedFragment === null) {
          fragment = this.build(dom);
          if (this.hasRendered) {
            this.cachedFragment = fragment;
          } else {
            this.hasRendered = true;
          }
        }
        if (this.cachedFragment) {
          fragment = dom.cloneNode(this.cachedFragment, true);
        }
      } else {
        fragment = this.build(dom);
      }
      var element11 = dom.childAt(fragment, [0]);
      var element12 = dom.childAt(element11, [0]);
      var morph0 = dom.createMorphAt(element12,0,0);
      var morph1 = dom.createMorphAt(element12,1,1);
      var morph2 = dom.createMorphAt(element12,2,2);
      var morph3 = dom.createMorphAt(dom.childAt(element12, [3]),0,0);
      var morph4 = dom.createMorphAt(element12,4,4);
      var morph5 = dom.createUnsafeMorphAt(dom.childAt(element11, [1]),0,0);
      block(env, morph0, context, "if", [get(env, context, "showDragEnableControl")], {}, child0, null);
      block(env, morph1, context, "if", [get(env, context, "newConfiguratorAvailable")], {}, child1, null);
      block(env, morph2, context, "if", [get(env, context, "canEditMenu")], {}, child2, null);
      block(env, morph3, context, "sm-sortable", [], {"disabled": get(env, context, "smSortableDisabled"), "onItemReorder": "reorderCategory"}, child3, null);
      block(env, morph4, context, "if", [get(env, context, "canEditMenu")], {}, child4, null);
      content(env, morph5, context, "outlet");
      return fragment;
    }
  };
}()));